const SHAPES = [
  ["portrait", "Portrait", "4:5", "w-8 h-10"],
  ["square", "Square", "1:1", "w-9 h-9"],
  ["landscape", "Landscape", "16:10", "w-12 h-[30px]"],
];

// Pick the frame shape every Works tile uses. Artwork is never cropped inside it.
export const TileShapePicker = ({ value, onChange }) => (
  <div className="space-y-3">
    <div className="grid grid-cols-3 gap-2 sm:gap-3" role="radiogroup" aria-label="Works tile shape">
      {SHAPES.map(([id, label, ratio, box]) => {
        const on = (value || "portrait") === id;
        return (
          <button key={id} type="button" role="radio" aria-checked={on} data-testid={`site-tile-shape-${id}`} onClick={() => onChange(id)}
            className={`flex flex-col items-center gap-3 py-4 border transition-colors ${on ? "border-[#F5A524] bg-[#F5A524]/10 text-[#F5A524]" : "border-white/10 text-zinc-300 hover:border-[#F5A524]/50"}`}>
            <span className="h-11 grid place-items-center">
              <span className={`${box} clip-corner ${on ? "bg-[#F5A524]" : "bg-zinc-600"}`} />
            </span>
            <span className="font-mono text-[11px] tracking-[0.2em] uppercase">{label}</span>
            <span className="font-mono text-[10px] text-zinc-400">{ratio}</span>
          </button>
        );
      })}
    </div>
    <p className="text-xs text-zinc-400">Every tile in Works uses this shape. Artwork is never cropped: if a piece doesn't match the shape, the gap is filled with a soft blur of the piece itself.</p>
  </div>
);
